import type { EditTranslationsPrivilege } from '@skytech/types'

export function getEditTranslationsPrivilege(editTranslationPrivilegeId: number) {
  let editTranslationsPrivilege: EditTranslationsPrivilege = 'CANNOT_EDIT'
  switch (editTranslationPrivilegeId) {
    case 0: {
      editTranslationsPrivilege = 'CANNOT_EDIT'
      break
    }
    case 1: {
      editTranslationsPrivilege = 'CAN_EDIT_OWN_LANG'
      break
    }
    case 2: {
      editTranslationsPrivilege = 'CAN_EDIT_ALL_LANG'
      break
    }
  }

  return editTranslationsPrivilege
}
